/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import {
    UploadMediaMutation,
    UploadMediaMutationVariables
} from "@models/graphql";

export const useUploadMedia = (options?: MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) => useMutation<UploadMediaMutation, UploadMediaMutationVariables>(GraphQLDocuments.uploadMedia, options);
